export const COUNTRIES = ["日本", "泰国", "马来西亚", "格鲁吉亚", "哥伦比亚", "吉尔吉斯斯坦"];

export const SERVICE_PLAN_CONFIG: Record<string, { group: string; label: string }> = {
  surrogacy_has_embryo: { group: "单助孕", label: "已有胚胎" },
  surrogacy_transfer_embryo: { group: "单助孕", label: "转入胚胎" },
  ivf_self: { group: "试管助孕", label: "自精自卵" },
  ivf_donor: { group: "试管助孕", label: "捐赠助孕" },
  embryo_transport: { group: "胚胎转运", label: "胚胎转出" },
  fertility_preservation: { group: "生育力保存", label: "生育力保存" },
};

export function formatServicePlan(planKey: string | null | undefined): string {
  if (!planKey) return "-";
  const cfg = SERVICE_PLAN_CONFIG[planKey];
  if (!cfg) return planKey;
  return `${cfg.group} · ${cfg.label}`;
}

export const SERVICE_PLAN_FLAT_LABELS: Record<string, string> = {
  surrogacy_has_embryo: "单助孕-已有胚胎",
  surrogacy_transfer_embryo: "单助孕-转入胚胎",
  ivf_self: "试管助孕-自精自卵",
  ivf_donor: "试管助孕-捐赠助孕",
  embryo_transport: "胚胎转运-胚胎转出",
  fertility_preservation: "生育力保存-生育力保存",
};

export const SERVICE_PLANS = Object.entries(SERVICE_PLAN_CONFIG).map(([value, cfg]) => ({
  value,
  label: `${cfg.group} → ${cfg.label}`,
  group: cfg.group,
}));

export const JOINT_STIM_PLANS = new Set(["ivf_self", "ivf_donor"]);

export const CLIENT_SOURCES = [
  { value: "shangqiao", label: "商桥" },
  { value: "channel", label: "渠道" },
  { value: "promotion", label: "推广" },
  { value: "love", label: "大爱" },
  { value: "media", label: "新媒体" },
  { value: "referral", label: "内部推荐" },
  { value: "other", label: "其他" },
];

export const CLIENT_SOURCE_LABELS: Record<string, string> = {
  shangqiao: "商桥", channel: "渠道", promotion: "推广",
  love: "大爱", media: "新媒体", referral: "内部推荐", other: "其他",
};

export const COUNTRY_CODE_MAP: Record<string, string> = {
  "吉尔吉斯斯坦": "K", "马来西亚": "M", "日本": "J", "格鲁吉亚": "G", "哥伦比亚": "C", "泰国": "T",
};

export const PLAN_CODE_MAP: Record<string, string> = {
  surrogacy_has_embryo: "DY", surrogacy_transfer_embryo: "DZ",
  ivf_self: "SZ", ivf_donor: "SJ",
  embryo_transport: "PZ", fertility_preservation: "SS",
};

export const SOURCE_CODE_MAP: Record<string, string> = {
  shangqiao: "S", channel: "Q", promotion: "T", love: "D",
  media: "X", referral: "N", other: "O",
};

export function generateClientCode(country: string, servicePlan: string, clientSource: string): string {
  const c = COUNTRY_CODE_MAP[country] || "K";
  const p = PLAN_CODE_MAP[servicePlan] || "DY";
  const s = SOURCE_CODE_MAP[clientSource] || "O";
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let random = "";
  for (let i = 0; i < 7; i++) {
    random += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return c + p + s + random;
}

export function formatDate(d: string) {
  const dt = new Date(d);
  return `${dt.getFullYear()}.${String(dt.getMonth() + 1).padStart(2, "0")}.${String(dt.getDate()).padStart(2, "0")}`;
}

export function formatDateTimeShort(s: string | null) {
  if (!s) return "-";
  const d = new Date(s);
  return `${String(d.getMonth() + 1).padStart(2, "0")}.${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}